export default "__VITE_ASSET__939a096a__"